import { FC, useState } from "react";
import styles from "./ModelInfo.module.scss";
import close from "../../images/icons/AdminPanel/close.svg";
import { IPhoto, IRequestPatchUser } from "../../types/user";
import { Button } from "../ui";
import ImageUploader from "../ui/ImageUploader/ImageUploader";
import { useAppDispatch, useAppSelector } from "../../services/hooks";
import { fetchUser, updateUser } from "../../services/slices/user";
import { ErrorPage } from "../../pages/ErrorPage/ErrorPage";
import { deletePhoto } from "../../api/user";

type IApploading = {
  imageList: Array<String>;
  onImageUpload: () => void;
  onImageRemoveAll: () => void;
  onImageUpdate: (value: number) => void;
  onImageRemove: (deleteIndex: number | number[]) => void;
};

export const BlockImage: FC<{ dataImage: Array<IPhoto> }> = ({ dataImage }) => {
  const [dimmedImages, setDimmedImages] = useState<number[]>([]);
  const [images, setImages] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();

  const handleDimToggle = (id: number) => {
    setDimmedImages((prev) =>
      prev.includes(id) ? prev.filter((imgId) => imgId !== id) : [...prev, id],
    );
  };

  const handleImageRemove = (image: string) => {
    setImages((prev) =>
      prev.includes(image)
        ? prev.filter((img) => img !== image)
        : [...prev, image],
    );
  };

  async function patchUser() {
    const newPhoto: IRequestPatchUser = {
      gallery: images,
    };
    const newAvatar: IRequestPatchUser = {
      profileAvatar: {
        avatarUrl: images[0],
      },
    };
    if (user?.profileAvatar === null) {
      dispatch(updateUser(newAvatar));
      dispatch(updateUser(newPhoto));
    } else {
      dispatch(updateUser(newPhoto));
    }
  }

  async function patchUserAvatar(avatar: string) {
    const newAvatar: IRequestPatchUser = {
      profileAvatar: {
        avatarUrl: avatar,
        onDoubleTap: true,
      },
    };
    dispatch(updateUser(newAvatar));
  }

  async function deletedPhotos() {
    try {
      setIsLoading(true);
      const data = {
        photoIds: dimmedImages,
      };
      await deletePhoto(data);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
      dispatch(fetchUser());
    }
  }

  return (
    <div className={styles.BlockImage}>
      <div className={styles.NewPhoto}>
        <ImageUploader
          images={images}
          setImage={setImages}
          handleImageRemove={(img) => handleImageRemove(img)}
        />
        <div className={styles.Button}>
          <Button onClick={patchUser}>Save</Button>
        </div>
      </div>
      <div className={styles.OldPhoto}>
        <div className={styles.OldPhoto_conteiner}>
          {dataImage.length !== 0 ? (
            dataImage.map((imag) => (
              <div className={styles.PhotoItem} key={imag.id}>
                <img
                  src={close}
                  alt="Icon"
                  className={styles.Icon}
                  onClick={() => handleDimToggle(imag.id)}
                />
                <img
                  src={imag.photoUrl}
                  alt="Photo"
                  onDoubleClick={() => patchUserAvatar(imag.photoUrl)}
                  className={`${styles.Image} ${
                    dimmedImages.includes(imag.id) && styles.Image_hover
                  }`}
                />
              </div>
            ))
          ) : (
            <p>Keine Fotos hinzugefügt</p>
          )}
        </div>
        <div className={styles.Button}>
          <Button onClick={deletedPhotos}>Delete</Button>
        </div>
      </div>
    </div>
  );
};
